<template>
  <div class="trade">
    <div class="tradetop">
      <div class="d-flex tradetopItem">
        <img
          style="margin-left: 8px"
          :src="yingyuedu >= 0 ? imgSrc : imgSrc1"
          alt="盈余"
        />
        <div :class="yingyuedu >= 0 ? 'tradetopText' : 'tradetopText1'">
          <span :style="yingyuedu >= 0 ? 'color:#5be7b9' : 'color:#fd0d58'"
            >总<br />用量 <b>{{ yingyuedu }}</b
            >万吨</span
          >
        </div>
      </div>
      <div class="d-flex tradetopItem">
        <img src="../../assets/yushouyi.png" alt="预计收益" />
        <div class="tradetopTextNomal">
          <span class=""
            >总<br />耗费<b>{{ incomeMoney }}</b
            >万元</span
          >
        </div>
      </div>
    </div>
    <div class="priceGoing">
      <img
        class="traveImg"
        style="max-width: 25px; margin-left: 12px"
        src="../../assets/tloading.png"
        alt="用电单价以及建议单价"
      />
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
        "
      >
        <span style="padding: 0px 5px 0px 15px; width: 130%"
          >用电单价及建议单价</span
        >
        <div
          style="
            display: block;
            width: inherit;
            height: 1px;
            background-color: #20354c;
          "
        ></div>
      </div>
      <img
        style="max-width: 26px"
        src="../../assets/tright.png"
        alt="全国碳配额市场价格走势"
      />
    </div>
    <div id="priceTrend" style="height: 200px"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: "trade",
  props: {
    yingyue: {
      type: Number,
      default: null
    },
    income: {
      type: Number,
      default: null
    },
    tradexData: {
      type: Array,
      default: null
    },
    ccerData: {
      type: Array,
      default: null
    },
    quotaData: {
      type: Array,
      default: null
    },
  },
  data () {
    return {
      yingyuStatus: 1,
      imgSrc: require('../..//assets/ying1.png'), // 盈余 绿
      imgSrc1: require('../../assets/ying2.png'), // 盈余 红
      yingyuedu: 0,
      incomeMoney: 0,
      tradechartDom: {}
    }
  },
  methods: {
    chartInvid () {
      this.tradechartDom = echarts.init(document.getElementById("priceTrend"));
      this.tradechartDom.setOption(this.tradechartDom);
    }
  },
  watch: {
    yingyue (newValue) {
      if (newValue != null) {
        this.yingyuedu = newValue.toFixed(2)
        // this.yingyuedu = (Number(newValue) / 10000).toFixed(2)
      }
    },
    income (newValue) {
      if (newValue != null) {
        this.incomeMoney = newValue.toFixed(1)
        // this.yingyuedu = (Number(newValue) / 10000).toFixed(2)
      }
    },
    tradexData (newValue) {
      if (newValue != null) {
        this.tradexData = newValue
      }
    },
    ccerData (newValue) {
      if (newValue != null) {
        this.ccerData = newValue
      }
    },
    quotaData (newValue) {
      if (newValue != null) {
        this.quotaData = newValue
        // setTimeout(function () {
        let tradechartDom = document.getElementById('priceTrend');
        let trademyChart = echarts.init(tradechartDom);
        trademyChart.setOption(this.optionTrend)
        // }, 1000)
        // debugger
      }
    },
  },
  computed: {
    optionTrend () {
      return {
        title: {
          text: '单位:元/吨',
          textStyle: {
            color: '#fff',
            fontSize: 14,
          }
        },
        tooltip: {
          padding: [8, 10, 8, 10],
          backgroundColor: 'rgba(9,17,24)',
          borderWidth: 1,
          borderColor: '#45a2ff',
          trigger: 'axis',
          formatter: function (params) {
            var res = ''
            for (var i = 0, l = params.length; i < l; i++) {
              res += params[i].seriesName + ' : ' + params[i].value + '<br/>';//鼠标悬浮显示的字符串内容
              // console.log(res)
            }
            var str = `<div style="color:#fff; background-size: cover;;font-size:16px;">`
              + res +
              `</div>`;
            // parms.marker
            // console.log(params);
            return str;

          }
        },
        legend: {
          // data: ['Email', 'Union Ads'],
          right: 10,
          textStyle: {
            color: '#fff',
            fontSize: 16
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          // feature: {
          //   saveAsImage: {}
          // }
        },
        xAxis: {
          // show: 'false,
          type: 'category',
          boundaryGap: true,
          data: this.tradexData,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#45a2ff',
            },
          },
          splitLine: { show: false },//去除网格线
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontSize: 16,
            color: '#fff',
          },
        },
        yAxis: {
          type: 'value',
          scale: true,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#45a2ff',
            },
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#182266',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontSize: 16,
            color: '#fff',
          },
        },
        series: [
          {
            name: '用电单价',
            type: 'line',
            // stack: 'Total',
            showSymbol: true,//是否默认展示圆点
            legendHoverLink: true,
            // 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none'
            symbol: 'circle',     //设定为实心点
            symbolSize: 12,   //设定实心点的大小
            data: this.ccerData
          },
          {
            name: '参考价',
            type: 'line',
            // stack: 'Total',
            showSymbol: true,//是否默认展示圆点
            legendHoverLink: true,
            // 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none'
            symbol: 'circle',     //设定为实心点
            symbolSize: 12,   //设定实心点的大小
            data: this.quotaData,


          }
        ]
      }
    }
  },
  mounted () {


  }
}
</script>

<style scoped>
.tradetop {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 5px;
}
.tradetopItem img {
  max-width: 50px;
}
.tradetopItem div {
  background-color: rgba(24, 38, 60);
  margin-left: 0px;
  padding: 5px 10px;
}
.tradetopItem span {
  font-size: 16px;
  display: flex;
  align-items: center;
}
.tradetopItem span b {
  font-size: 24px;
  font-weight: normal;
  padding: 0px 3px;
}
.priceGoing {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/right/trade.vue